import styled from "styled-components";
import { Typography } from "@mui/material";
import { theme } from "../../utils/globalStyles/colors";
import PaidIcon from "@mui/icons-material/Paid";

export const Container = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 24px 16px 0; /* o espaço do menu inferior fica no BodyContainer */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

/* Novo Cartão de Saldo Premium */
export const BalanceCard = styled.div`
  width: 100%;
  background: linear-gradient(135deg, ${theme.colors.base}, #e68a47);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(211, 114, 40, 0.3);
  margin-bottom: 24px;
  box-sizing: border-box;
`;

export const Balance = styled(Typography)`
  color: rgba(255, 255, 255, 0.8) !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const BalanceValue = styled(Typography)`
  color: #ffffff !important;
  font-weight: 800 !important;
  font-size: 36px !important;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px !important;
`;

export const TransferIcon = styled(PaidIcon)`
  color: #ffffff !important;
  font-size: 32px !important;
`;

/* Menu de Abas Segmentado */
export const TabContainer = styled.div`
  display: flex;
  background-color: #e9ecef;
  border-radius: 12px;
  padding: 4px;
  width: 100%;
  margin-bottom: 24px;
  box-sizing: border-box;
`;

export const TabButton = styled.div<{ active: boolean }>`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${(props) => (props.active ? "#ffffff" : "transparent")};
  box-shadow: ${(props) =>
    props.active ? "0 2px 8px rgba(0,0,0,0.1)" : "none"};
  color: ${(props) => (props.active ? theme.colors.base : "#888888")};
  font-weight: bold;
  font-size: 13px;
  transition: all 0.2s ease;
`;

export const InfoContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
`;
